import { render, staticRenderFns } from "./spc_livecharts.vue?vue&type=template&id=63c90efc"
import script from "./spc_livecharts.vue?vue&type=script&lang=js"
export * from "./spc_livecharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports